export const appZIndex = {
  modal: 10000000000000000,
  tooltips: 10000000000000001,
  drawer: 1000000000000001,
};

export interface DownloadProgress {
  bookId: number;
  fileName: string;
  progress: number;
  status: "downloading" | "completed" | "error" | "pending";
}

export const nigeriaState = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT - Abuja",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

export const nigeriaBank = [
  {
    name: "9 PAYMENT SOLUTIONS BANK",
    code: "120001",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AB MICROFINANCE BANK ",
    code: "090270",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ABBEY MORTGAGE BANK",
    code: "070010",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ABOVE ONLY MICROFINANCE BANK ",
    code: "090260",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ABU MICROFINANCE BANK ",
    code: "090197",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Access bank",
    code: "044",
    ussdTemplate: "*901*Amount*AccountNumber#",
    baseUssdCode: "*901#",
    transferUssdTemplate: "*901*AccountNumber#",
  },
  {
    name: "ACCESS MONEY",
    code: "927",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ACCESS YELLO & BETA",
    code: "100052",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ACCION MICROFINANCE BANK",
    code: "090134",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ADDOSSER MICROFINANCE BANK",
    code: "090160",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ADEYEMI COLLEGE STAFF MICROFINANCE BANK",
    code: "090268",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AFEKHAFE MICROFINANCE BANK",
    code: "090292",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AG MORTGAGE BANK",
    code: "100028",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AL-BARAKAH MICROFINANCE BANK",
    code: "090133",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ALEKUN MICROFINANCE BANK",
    code: "090259",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ALERT MICROFINANCE BANK",
    code: "090297",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ALLWORKERS MICROFINANCE BANK",
    code: "090131",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ALPHA KAPITAL MICROFINANCE BANK ",
    code: "090169",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AMML MICROFINANCE BANK ",
    code: "914",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "APEKS MICROFINANCE BANK",
    code: "090143",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ARISE MICROFINANCE BANK",
    code: "090282",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ASO SAVINGS",
    code: "905",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ASSETMATRIX MICROFINANCE BANK",
    code: "090287",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ASTRAPOLARIS MICROFINANCE BANK",
    code: "090172",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "AUCHI MICROFINANCE BANK ",
    code: "090264",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BAINES CREDIT MICROFINANCE BANK",
    code: "090188",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BALOGUN GAMBARI MICROFINANCE BANK",
    code: "090326",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BC KASH MICROFINANCE BANK",
    code: "090127",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BIPC MICROFINANCE BANK",
    code: "090336",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BOCTRUST MICROFINANCE BANK LIMITED",
    code: "952",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BOSAK MICROFINANCE BANK",
    code: "090176",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Bowen Microfinance Bank",
    code: "50931",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BRENT MORTGAGE BANK",
    code: "070015",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "BRIGHTWAY MICROFINANCE BANK",
    code: "090308",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CASHCONNECT MICROFINANCE BANK",
    code: "090360",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CELLULANT",
    code: "919",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CEMCS Microfinance Bank",
    code: "50823",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CHAMS MOBILE",
    code: "929",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CHIKUM MICROFINANCE BANK",
    code: "090141",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CIT MICROFINANCE BANK",
    code: "090144",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Citibank Nigeria",
    code: "023",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "COASTLINE MICROFINANCE BANK",
    code: "090374",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CONPRO MICROFINANCE BANK",
    code: "090380",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CONSUMER MICROFINANCE BANK",
    code: "090130",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CONTEC GLOBAL INFOTECH LIMITED(NOWNOW)",
    code: "100032",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CORESTEP MICROFINANCE BANK",
    code: "090365",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Coronation Bank",
    code: "559",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "COVENANT MFB",
    code: "949",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "CREDIT AFRIQUE MICROFINANCE BANK",
    code: "090159",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "DAVODANI  MICROFINANCE BANK",
    code: "090391",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "DAYLIGHT MICROFINANCE BANK",
    code: "090167",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Diamond bank",
    code: "063",
    ussdTemplate: "*710*777*AccountNumber*Amount#",
    baseUssdCode: "*710#",
    transferUssdTemplate: "*710*AccountNumber#",
  },
  {
    name: "E-BARCS MICROFINANCE BANK",
    code: "090156",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EAGLE FLIGHT MICROFINANCE BANK",
    code: "090294",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EARTHOLEUM",
    code: "935",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Ecobank Nigeria Plc",
    code: "050",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ECOBANK XPRESS ACCOUNT",
    code: "922",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ECOMOBILE",
    code: "307",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EK-RELIABLE MICROFINANCE BANK",
    code: "090389",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EKONDO MICROFINANCE BANK",
    code: "090097",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EMERALD MICROFINANCE BANK",
    code: "090273",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EMPIRE TRUST MICROFINANCE BANK",
    code: "913",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ENTERPRISE BANK",
    code: "084",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ESO-E MICROFINANCE BANK",
    code: "090166",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "eTRANZACT",
    code: "920",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EVANGEL MICROFINANCE BANK ",
    code: "090304",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "EVERGREEN MICROFINANCE BANK",
    code: "090332",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Eyowo",
    code: "50126",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FAST MICROFINANCE BANK",
    code: "090179",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FBNQUEST MERCHANT BANK",
    code: "911",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FCMB MOBILE",
    code: "100031",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FCT MICROFINANCE BANK",
    code: "090290",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FEDPOLY NASARAWA MICROFINANCE BANK",
    code: "090298",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FETS",
    code: "915",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FFS MICROFINANCE BANK",
    code: "090153",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Fidelity bank",
    code: "070",
    ussdTemplate: "*770*AccountNumber*Amount#",
    baseUssdCode: "*770#",
    transferUssdTemplate: "*770*AccountNumber#",
  },
  {
    name: "FIDELITY MOBILE",
    code: "933",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIDFUND MICROFINANCE Bank",
    code: "090126",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FINATRUST MICROFINANCE BANK",
    code: "090111",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FINCA MICROFINANCE BANK",
    code: "090400",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIRMUS MICROFINANCE BANK",
    code: "090366",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "First bank",
    code: "011",
    ussdTemplate: "*894*Amount*AccountNumber#",
    baseUssdCode: "*894#",
    transferUssdTemplate: "*894*AccountNumber#",
  },
  {
    name: "First City Monument Bank Plc",
    code: "214",
    ussdTemplate: "*329*Amount*AccountNumber#",
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIRST GENERATION MORTGAGE BANK",
    code: "070014",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIRST OPTION MICROFINANCE BANK",
    code: "090285",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIRST TRUST MORTGAGE BANK PLC",
    code: "910",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FIRSTMONIE WALLET",
    code: "928",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FLUTTERWAVE TECHNOLOGY SOLUTIONS LIMITED",
    code: "110002",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FORTIS MICROFINANCE BANK",
    code: "948",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FORTIS MOBILE",
    code: "930",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FSDH",
    code: "400001",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FULLRANGE MICROFINANCE BANK",
    code: "090145",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "FUTO MICROFINANCE BANK",
    code: "090158",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GATEWAY MORTGAGE BANK",
    code: "070009",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Globus Bank",
    code: "00103",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GLORY MICROFINANCE BANK",
    code: "090278",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GOWANS MICROFINANCE BANK",
    code: "090122",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GREENBANK MICROFINANCE BANK",
    code: "090178",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GROOMING MICROFINANCE BANK",
    code: "090195",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GT MOBILE",
    code: "923",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "GTBank",
    code: "058",
    ussdTemplate: "*737*2*Amount*AccountNumber#",
    baseUssdCode: "*737#",
    transferUssdTemplate: "*737*AccountNumber#",
  },
  {
    name: "GTI MICROFINANCE BANK",
    code: "090385",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Hackman Microfinance Bank",
    code: "51251",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "HAGGAI MORTGAGE BANK LIMITED",
    code: "070017",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Hasal Microfinance Bank",
    code: "50383",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "HEADWAY MICROFINANCE BANK",
    code: "090363",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "HEDONMARK",
    code: "931",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Heritage bank",
    code: "030",
    ussdTemplate: "*322*030*AccountNumber*Amount#",
    baseUssdCode: "*322#",
    transferUssdTemplate: "*322*AccountNumber#",
  },
  {
    name: "Ibile Microfinance Bank",
    code: "51244",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IKENNE MICROFINANCE BANK",
    code: "090324",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IKIRE MICROFINANCE BANK",
    code: "090275",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IKIRE MICROFINANCE BANK",
    code: "090279",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ILISAN MICROFINANCE BANK",
    code: "090370",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IMO STATE MICROFINANCE BANK",
    code: "090258",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IMPERIAL HOMES MORTGAGE BANK",
    code: "938",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Infinity MFB",
    code: "50457",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "INFINITY TRUST MORTGAGE BANK",
    code: "070016",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "INNOVECTIVES KESH",
    code: "100029",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "INTELLFIN",
    code: "941",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "INTERLAND MICROFINANCE BANK",
    code: "090386",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "IRL MICROFINANCE BANK",
    code: "090149",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ISALEOYO MICROFINANCE BANK",
    code: "090377",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "JAIZ BANK",
    code: "301",
    ussdTemplate: "*389*301*AccountNumber*Amount#",
    baseUssdCode: "*389#",
    transferUssdTemplate: "*389*AccountNumber#",
  },
  {
    name: "JUBILEE LIFE",
    code: "906",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Keystone bank",
    code: "082",
    ussdTemplate: "*7111*Amount*AccountNumber#",
    baseUssdCode: "*7111#",
    transferUssdTemplate: "*7111*AccountNumber#",
  },
  {
    name: "KONTAGORA MICROFINANCE BANK",
    code: "090299",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Kuda Microfinance Bank",
    code: "50211",
    ussdTemplate: null,
    baseUssdCode: "*5573#",
    transferUssdTemplate: "*5573*AccountNumber#",
  },
  {
    name: "LAGOS BUILDING AND INVESTMENT COMPANY",
    code: "070012",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Lagos Building Investment Company Plc.",
    code: "90052",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "LAPO MICROFINANCE BANK",
    code: "090177",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "LAVENDER MICROFINANCE BANK",
    code: "090271",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "LEGEND MICROFINANCE BANK",
    code: "090372",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MAINSTREET MICROFINANCE BANK",
    code: "090171",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MANNY MICROFINANCE BANK",
    code: "090383",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MAYFAIR MICROFINANCE BANK",
    code: "090321",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MAYFRESH MORTGAGE BANK",
    code: "070019",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MEGAPRAISE MICROFINANCE BANK",
    code: "090280",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MICROCRED MICROFINANCE BANK",
    code: "090136",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MICROVIS MICROFINANCE BANK ",
    code: "090113",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MINT-FINEX MFB",
    code: "090281",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MOLUSI MICROFINANCE BANK",
    code: "090362",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MONEY BOX",
    code: "934",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MONEY TRUST MICROFINANCE BANK",
    code: "963",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MOZFIN MICROFINANCE BANK",
    code: "090392",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "MUTUAL TRUST MICROFINANCE BANK",
    code: "090151",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NDIORAH MICROFINANCE BANK",
    code: "090128",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NEPTUNE MICROFINANCE BANK",
    code: "090329",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NEW DAWN MICROFINANCE BANK",
    code: "090205",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NEW GOLDEN PASTURES MICROFINANCE BANK",
    code: "090378",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NIGERIAN NAVY MICROFINANCE BANK ",
    code: "090263",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NIRSAL NATIONAL MICROFINANCE BANK",
    code: "090194",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NNEW WOMEN MICROFINANCE BANK",
    code: "090283",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NOVA MERCHANT BANK",
    code: "637",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NPF MICROFINANCE BANK",
    code: "947",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NUTURE MICROFINANCE BANK",
    code: "090364",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "NWANNEGADI MICROFINANCE BANK",
    code: "090399",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OCHE MICROFINANCE BANK",
    code: "090333",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OHAFIA MICROFINANCE BANK",
    code: "090119",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OKPOGA MICROFINANCE BANK",
    code: "090161",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OLABISI ONABANJO UNIVERSITY MICROFINANCE ",
    code: "090272",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OMIYE MICROFINANCE BANK",
    code: "090295",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OMOLUABI",
    code: "950",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ONE FINANCE",
    code: "940",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "OPAY",
    code: "304",
    ussdTemplate: null,
    baseUssdCode: "",
    transferUssdTemplate: null,
  },
  {
    name: "OPAY 2",
    code: "305",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PAGA",
    code: "100002",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PAGE MFBank",
    code: "951",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PALMPAY",
    code: "100033",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PARALLEX",
    code: "907",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PARKWAY-READYCASH",
    code: "917",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PATRICKGOLD MICROFINANCE BANK",
    code: "090317",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PAYATTITUDE ONLINE",
    code: "943",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PAYSTACK PAYMENTS LIMITED",
    code: "110006",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PECANTRUST MICROFINANCE BANK",
    code: "090137",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PENNYWISE MICROFINANCE BANK ",
    code: "090196",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PERSONAL TRUST MICROFINANCE BANK",
    code: "090135",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Petra Mircofinance Bank Plc",
    code: "50746",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PILLAR MICROFINANCE BANK",
    code: "090289",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PLATINUM MORTGAGE BANK",
    code: "070013",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Polaris Bank",
    code: "076",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "POLYUNWANA MICROFINANCE BANK",
    code: "090296",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PRESTIGE MICROFINANCE BANK",
    code: "090274",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Providus Bank",
    code: "101",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "PURPLEMONEY MICROFINANCE BANK",
    code: "090303",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "QUICKFUND MICROFINANCE BANK",
    code: "090261",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "RAND MERCHANT BANK",
    code: "502",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "REFUGE MORTGAGE BANK",
    code: "070011",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "REGENT MICROFINANCE BANK",
    code: "955",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "RENMONEY MICROFINANCE BANK ",
    code: "090198",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "REPHIDIM MICROFINANCE BANK",
    code: "090322",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "RICHWAY MICROFINANCE BANK",
    code: "090132",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Rolez Microfinance Bank",
    code: "50515",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ROYAL EXCHANGE MICROFINANCE BANK",
    code: "090138",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Rubies Micro-finance Bank",
    code: "125",
    ussdTemplate: "090175",
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "RUBIES MICROFINANCE BANK",
    code: "090175",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SAFE HAVEN MICROFINANCE BANK",
    code: "090286",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SAFETRUST",
    code: "909",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SAGAMU MICROFINANCE BANK",
    code: "966",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SEED CAPITAL MICROFINANCE BANK",
    code: "609",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SEEDVEST MICROFINANCE BANK",
    code: "090369",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Sparkle Microfinance Bank",
    code: "51310",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "STANBIC IBTC @Ease WALLET",
    code: "921",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Stanbic IBTC Bank Ltd.",
    code: "221",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Standard Chartered Bank Nigeria Ltd.",
    code: "068",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "STELLAS MICROFINANCE BANK ",
    code: "090262",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Sterling bank",
    code: "232",
    ussdTemplate: "*822*5*Amount*AccountNumber#",
    baseUssdCode: "*822#",
    transferUssdTemplate: "*822*AccountNumber#",
  },
  {
    name: "STERLING MOBILE",
    code: "936",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "SULSPAP MICROFINANCE BANK",
    code: "090305",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Suntrust Bank Nigeria Limited",
    code: "100",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TAGPAY",
    code: "937",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Taj Bank",
    code: "302",
    ussdTemplate: null,
    baseUssdCode: "*898#",
    transferUssdTemplate: "*898*AccountNumber#",
  },
  {
    name: "TCF MFB",
    code: "51211",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TEASY MOBILE",
    code: "924",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "THINK FINANCE MICROFINANCE BANK",
    code: "090373",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Titan Bank",
    code: "102",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TRIDENT MICROFINANCE BANK",
    code: "090146",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TRUST MICROFINANCE BANK",
    code: "090327",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TRUSTBANC J6 MICROFINANCE BANK LIMITED",
    code: "090123",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "TRUSTFUND MICROFINANCE BANK ",
    code: "090276",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "U & C MICROFINANCE BANK",
    code: "090315",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "UNAAB MICROFINANCE BANK",
    code: "090331",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Unical Microfinance Bank",
    code: "50871",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Union bank",
    code: "032",
    ussdTemplate: "*826*2*Amount*AccountNumber#",
    baseUssdCode: "*826#",
    transferUssdTemplate: "*826*AccountNumber#",
  },
  {
    name: "United Bank For Africa Plc",
    code: "033",
    ussdTemplate: "*919*4*AccountNumber*Amount#",
    baseUssdCode: "*919#",
    transferUssdTemplate: "*919*AccountNumber#",
  },
  {
    name: "Unity Bank Plc",
    code: "215",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "UNIVERSITY OF NIGERIA, NSUKKA MICROFINANCE BANK",
    code: "090251",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "VENTURE GARDEN NIGERIA LIMITED",
    code: "110009",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "VFD microfinance bank",
    code: "566",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "VIRTUE MICROFINANCE BANK",
    code: "090150",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "VISA MICROFINANCE BANK",
    code: "090139",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "VT NETWORKS",
    code: "926",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Wema bank",
    code: "035",
    ussdTemplate: "*945*AccountNumber*Amount#",
    baseUssdCode: "*945#",
    transferUssdTemplate: "*945*AccountNumber#",
  },
  {
    name: "WETLAND  MICROFINANCE BANK",
    code: "954",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "XSLNCE MICROFINANCE BANK",
    code: "090124",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "YES MICROFINANCE BANK",
    code: "090142",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "YOBE MICROFINANCE  BANK",
    code: "090252",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "Zenith bank",
    code: "057",
    ussdTemplate: "*966*Amount*AccountNumber#",
    baseUssdCode: "*966#",
    transferUssdTemplate: "*966*AccountNumber#",
  },
  {
    name: "ZENITH MOBILE",
    code: "932",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
  {
    name: "ZINTERNET - KONGAPAY",
    code: "939",
    ussdTemplate: null,
    baseUssdCode: null,
    transferUssdTemplate: null,
  },
];

export const billPackages = [
  {
    id: 34,
    biller_code: "BIL119",
    name: "DSTV Payment",
    default_commission: 0.1,
    date_added: "2020-09-17T15:56:58.057Z",
    country: "NG",
    is_airtime: false,
    biller_name: "DSTV Payment",
    item_code: "CB140",
    short_name: "DSTV Premium",
    fee: 100,
    commission_on_fee: true,
    reg_expression: "^[0-9]+$",
    label_name: "SmartCard Number",
    amount: 14600,
    is_resolvable: true,
    group_name: "DSTV",
    category_name: "Cable Bill Payment",
    is_data: null,
    default_commission_on_amount: null,
    commission_on_fee_or_amount: null,
    validity_period: null,
  },
  {
    id: 35,
    biller_code: "BIL119",
    name: "DSTV",
    default_commission: 0.1,
    date_added: "2020-09-17T15:56:58.057Z",
    country: "NG",
    is_airtime: false,
    biller_name: "DSTV Access",
    item_code: "CB141",
    short_name: "DSTV Access",
    fee: 100,
    commission_on_fee: true,
    reg_expression: "^[0-9]+$",
    label_name: "SmartCard Number",
    amount: 1800,
    is_resolvable: true,
    group_name: "DSTV",
    category_name: "Cable Bill Payment",
    is_data: null,
    default_commission_on_amount: null,
    commission_on_fee_or_amount: null,
    validity_period: null,
  },
  {
    id: 91,
    biller_code: "BIL119",
    name: "DSTV",
    default_commission: 0.1,
    date_added: "2020-09-17T15:56:58.057Z",
    country: "NG",
    is_airtime: false,
    biller_name: "DSTV Premium",
    item_code: "CB140",
    short_name: "DSTV",
    fee: 100,
    commission_on_fee: true,
    reg_expression: "^[0-9]+$",
    label_name: "SmartCard Number",
    amount: 14600,
    is_resolvable: true,
    group_name: "Cable Bill Payment",
    category_name: "Cable Bill Payment",
    is_data: null,
    default_commission_on_amount: null,
    commission_on_fee_or_amount: null,
    validity_period: null,
  },
];

export const billPackagesElectricity = [
  {
    id: "prepaid",
    biller_code: "prepaid",
    name: "PrePaid",
    biller_name: "Prepaid",
  },
  {
    id: "postpaid",
    biller_code: "postpaid",
    name: "PostPaid",
    biller_name: "Postpaid",
  },
];

export const billPackagesData = [
  {
    id: "500",
    biller_code: "MTN",
    name: "MTN SME Data 500MB – 30 Days",
    biller_name: "MTN",
    amount: 500,
  },
  {
    id: "M1024",
    biller_code: "MTN",
    name: "MTN SME Data 1GB – 30 Days",
    biller_name: "MTN",
    amount: 1024,
  },
  {
    id: "M2024",
    biller_code: "MTN",
    name: "MTN SME Data 2GB – 30 Days",
    biller_name: "MTN",
    amount: 2024,
  },
  {
    id: "3000",
    biller_code: "MTN",
    name: "MTN SME Data 3GB – 30 Days",
    biller_name: "MTN",
    amount: 3000,
  },
  {
    id: "5000",
    biller_code: "MTN",
    name: "MTN SME Data 5GB – 30 Days",
    biller_name: "MTN",
    amount: 5000,
  },
  {
    id: "10000",
    biller_code: "MTN",
    name: "MTN SME Data 10GB – 30 Days",
    biller_name: "MTN",
    amount: 10000,
  },
  {
    id: "mtn-20hrs-1500",
    biller_code: "MTN",
    name: "MTN Data 6GB – 7 Days",
    biller_name: "MTN",
    amount: 1500,
  },
  {
    id: "mtn-30gb-8000",
    biller_code: "MTN",
    name: "MTN Data 30GB – 30 Days",
    biller_name: "MTN",
    amount: 8000,
  },
  {
    id: "mtn-40gb-10000",
    biller_code: "MTN",
    name: "MTN Data 40GB – 30 Days",
    biller_name: "MTN",
    amount: 10000,
  },
  {
    id: "mtn-75gb-15000",
    biller_code: "MTN",
    name: "MTN Data 75GB – 30 Days",
    biller_name: "MTN",
    amount: 15000,
  },
  {
    id: "glo100x",
    biller_code: "Glo",
    name: "Glo Data 1GB – 5 Nights",
    biller_name: "Glo",
    amount: 100,
  },
  {
    id: "glo200x",
    biller_code: "Glo",
    name: "Glo Data 1.25GB – 1 Day (Sunday)",
    biller_name: "Glo",
    amount: 200,
  },
  {
    id: "G500",
    biller_code: "Glo",
    name: "Glo Data 1.35GB – 14 Days",
    biller_name: "Glo",
    amount: 500,
  },
  {
    id: "G2000",
    biller_code: "Glo",
    name: "Glo Data 5.8GB – 30 Days",
    biller_name: "Glo",
    amount: 2000,
  },
  {
    id: "G1000",
    biller_code: "Glo",
    name: "Glo Data 2.9GB – 30 Days",
    biller_name: "Glo",
    amount: 1000,
  },
  {
    id: "G2500",
    biller_code: "Glo",
    name: "Glo Data 7.7GB – 30 Days",
    biller_name: "Glo",
    amount: 2500,
  },
  {
    id: "G3000",
    biller_code: "Glo",
    name: "Glo Data 10GB – 30 Days",
    biller_name: "Glo",
    amount: 3000,
  },
  {
    id: "G4000",
    biller_code: "Glo",
    name: "Glo Data 13.25GB – 30 Days",
    biller_name: "Glo",
    amount: 4000,
  },
  {
    id: "G5000",
    biller_code: "Glo",
    name: "Glo Data 18.25GB – 30 Days",
    biller_name: "Glo",
    amount: 5000,
  },
  {
    id: "G8000",
    biller_code: "Glo",
    name: "Glo Data 29.5GB – 30 Days",
    biller_name: "Glo",
    amount: 8000,
  },
  {
    id: "glo10000",
    biller_code: "Glo",
    name: "Glo Data 50GB – 30 Days",
    biller_name: "Glo",
    amount: 10000,
  },
  {
    id: "AIRTEL500MB",
    biller_code: "Airtel",
    name: "Airtel Data 500MB (Gift) – 30 Days",
    biller_name: "Airtel",
    amount: 500,
  },
  {
    id: "AIRTEL1GB",
    biller_code: "Airtel",
    name: "Airtel Data 1GB (Gift) – 30 Days",
    biller_name: "Airtel",
    amount: 1000,
  },
  {
    id: "AIRTEL2GB",
    biller_code: "Airtel",
    name: "Airtel Data 2GB (Gift)– 30 Days",
    biller_name: "Airtel",
    amount: 2000,
  },
  {
    id: "AIRTEL5GB",
    biller_code: "Airtel",
    name: "Airtel Data 5GB (Gift)– 30 Days",
    biller_name: "Airtel",
    amount: 5000,
  },
  {
    id: "AIRTEL10GB",
    biller_code: "Airtel",
    name: "Airtel Data 10GB (Gift)– 30 Days",
    biller_name: "Airtel",
    amount: 10000,
  },
  {
    id: "AIRTEL15GB",
    biller_code: "Airtel",
    name: "Airtel Data 15GB (Gift)– 30 Days",
    biller_name: "Airtel",
    amount: 15000,
  },
  {
    id: "AIRTEL20GB",
    biller_code: "Airtel",
    name: "Airtel Data 20GB (Gift)– 30 Days",
    biller_name: "Airtel",
    amount: 20000,
  },
  {
    id: "airt-1100",
    biller_code: "Airtel",
    name: "Airtel Data 1.5GB – 30 Days",
    biller_name: "Airtel",
    amount: 1100,
  },
  {
    id: "airt-1300",
    biller_code: "Airtel",
    name: "Airtel Data 2GB – 30 Days",
    biller_name: "Airtel",
    amount: 1300,
  },
  {
    id: "airt-1650",
    biller_code: "Airtel",
    name: "Airtel Data 3GB – 30 Days",
    biller_name: "Airtel",
    amount: 1650,
  },
  {
    id: "airt-2200",
    biller_code: "Airtel",
    name: "Airtel Data 4.5GB – 30 Days",
    biller_name: "Airtel",
    amount: 2200,
  },
  {
    id: "airt-3300",
    biller_code: "Airtel",
    name: "Airtel Data 10GB – 30 Days",
    biller_name: "Airtel",
    amount: 3300,
  },
  {
    id: "9mobile500",
    biller_code: "9mobile",
    name: "9mobile Data 500MB – 30 Days",
    biller_name: "9mobile",
    amount: 500,
  },
  {
    id: "9mobile1000",
    biller_code: "9mobile",
    name: "9mobile Data 1.5GB – 30 Days",
    biller_name: "9mobile",
    amount: 1000,
  },
  {
    id: "9mobile2000",
    biller_code: "9mobile",
    name: "9mobile Data 5GB – 30 Days",
    biller_name: "9mobile",
    amount: 2000,
  },
  {
    id: "9mobile3000",
    biller_code: "9mobile",
    name: "9mobile Data 8GB – 30 Days",
    biller_name: "9mobile",
    amount: 3000,
  },
  {
    id: "9mobile4000",
    biller_code: "9mobile",
    name: "9mobile Data 11GB – 30 Days",
    biller_name: "9mobile",
    amount: 4000,
  },
  {
    id: "9mobile8000",
    biller_code: "9mobile",
    name: "9mobile Data 25GB – 30 Days",
    biller_name: "9mobile",
    amount: 8000,
  },
  {
    id: "9mobile15000",
    biller_code: "9mobile",
    name: "9mobile Data 50GB – 30 Days",
    biller_name: "9mobile",
    amount: 15000,
  },
];

export const billPackagesCableTV = [
  {
    id: "dstv-padi",
    name: "DStv Padi",
    biller_name: "DStv",
    amount: 2500,
    fee: 100,
  },
  {
    id: "dstv-yanga",
    name: "DStv Yanga",
    biller_name: "DStv",
    amount: 3500,
    fee: 100,
  },
  {
    id: "dstv-confam",
    name: "DStv Confam",
    biller_name: "DStv",
    amount: 5300,
    fee: 100,
  },
  {
    id: "dstv6",
    name: "DStv Asia",
    biller_name: "DStv",
    amount: 6000,
    fee: 100,
  },
  {
    id: "dstv79",
    name: "DStv Compact",
    biller_name: "DStv",
    amount: 7900,
    fee: 100,
  },
  {
    id: "dstv7",
    name: "DStv Compact Plus",
    biller_name: "DStv",
    amount: 10500,
    fee: 100,
  },
  {
    id: "dstv3",
    name: "DStv Premium",
    biller_name: "DStv",
    amount: 15000,
    fee: 100,
  },
  {
    id: "dstv10",
    name: "DStv Premium Asia",
    biller_name: "DStv",
    amount: 17000,
    fee: 100,
  },
  {
    id: "dstv9",
    name: "DStv Premium-French",
    biller_name: "DStv",
    amount: 15000,
    fee: 100,
  },
  {
    id: "confam-extra",
    name: "DStv Confam + ExtraView",
    biller_name: "DStv",
    amount: 7000,
    fee: 100,
  },
  {
    id: "yanga-extra",
    name: "DStv Yanga + ExtraView",
    biller_name: "DStv",
    amount: 5000,
    fee: 100,
  },
  {
    id: "padi-extra",
    name: "DStv Padi + ExtraView",
    biller_name: "DStv",
    amount: 4500,
    fee: 100,
  },
  {
    id: "com-asia",
    name: "DStv Compact + Asia",
    biller_name: "DStv",
    amount: 12000,
    fee: 100,
  },
  {
    id: "dstv30",
    name: "DStv Compact + Extra View",
    biller_name: "DStv",
    amount: 9000,
    fee: 100,
  },
  {
    id: "com-frenchtouch",
    name: "DStv Compact + French Touch",
    biller_name: "DStv",
    amount: 9500,
    fee: 100,
  },
  {
    id: "dstv33",
    name: "DStv Premium – Extra View",
    biller_name: "DStv",
    amount: 15200,
    fee: 100,
  },
  {
    id: "dstv40",
    name: "DStv Compact Plus – Asia",
    biller_name: "DStv",
    amount: 11500,
    fee: 100,
  },
  {
    id: "com-frenchtouch-extra",
    name: "DStv Compact + French Touch + ExtraView",
    biller_name: "DStv",
    amount: 10000,
    fee: 100,
  },
  {
    id: "com-asia-extra",
    name: "DStv Compact + Asia + ExtraView",
    biller_name: "DStv",
    amount: 12500,
    fee: 100,
  },
  {
    id: "dstv43",
    name: "DStv Compact Plus + French Plus",
    biller_name: "DStv",
    amount: 11500,
    fee: 100,
  },
  {
    id: "complus-frenchtouch",
    name: "DStv Compact Plus + French Touch",
    biller_name: "DStv",
    amount: 12000,
    fee: 100,
  },
  {
    id: "dstv45",
    name: "DStv Compact Plus – Extra View",
    biller_name: "DStv",
    amount: 10800,
    fee: 100,
  },
  {
    id: "complus-french-extraview",
    name: "DStv Compact Plus + FrenchPlus + Extra View",
    biller_name: "DStv",
    amount: 12200,
    fee: 100,
  },
  {
    id: "dstv47",
    name: "DStv Compact + French Plus",
    biller_name: "DStv",
    amount: 10200,
    fee: 100,
  },
  {
    id: "dstv48",
    name: "DStv Compact Plus + Asia + ExtraView",
    biller_name: "DStv",
    amount: 13000,
    fee: 100,
  },
  {
    id: "dstv61",
    name: "DStv Premium + Asia + Extra View",
    biller_name: "DStv",
    amount: 18000,
    fee: 100,
  },
  {
    id: "dstv62",
    name: "DStv Premium + French + Extra View",
    biller_name: "DStv",
    amount: 15500,
    fee: 100,
  },
  {
    id: "hdpvr-access-service",
    name: "DStv HDPVR Access Service",
    biller_name: "DStv",
    amount: 2000,
    fee: 100,
  },
  {
    id: "frenchplus-addon",
    name: "DStv French Plus Add-on",
    biller_name: "DStv",
    amount: 1500,
    fee: 100,
  },
  {
    id: "asia-addon",
    name: "DStv Asian Add-on",
    biller_name: "DStv",
    amount: 2000,
    fee: 100,
  },
  {
    id: "frenchtouch-addon",
    name: "DStv French Touch Add-on",
    biller_name: "DStv",
    amount: 1000,
    fee: 100,
  },
  {
    id: "extraview-access",
    name: "ExtraView Access",
    biller_name: "DStv",
    amount: 500,
    fee: 100,
  },
  {
    id: "french11",
    name: "DStv French 11",
    biller_name: "DStv",
    amount: 1100,
    fee: 100,
  },
  {
    id: "gotv-smallie",
    name: "GOtv Smallie",
    biller_name: "GOtv",
    amount: 900,
    fee: 100,
  },
  {
    id: "gotv-jinja",
    name: "GOtv Jinja",
    biller_name: "GOtv",
    amount: 1600,
    fee: 100,
  },
  {
    id: "gotv-jolli",
    name: "GOtv Jolli",
    biller_name: "GOtv",
    amount: 2460,
    fee: 100,
  },
  {
    id: "gotv-max",
    name: "GOtv Max",
    biller_name: "GOtv",
    amount: 3280,
    fee: 100,
  },
  {
    id: "gotv-supa",
    name: "GOtv Supa",
    biller_name: "GOtv",
    amount: 4000,
    fee: 100,
  },
  {
    id: "nova",
    name: "Startimes Nova",
    biller_name: "Startimes",
    amount: 900,
    fee: 100,
  },
  {
    id: "basic",
    name: "Startimes Basic",
    biller_name: "Startimes",
    amount: 1500,
    fee: 100,
  },
  {
    id: "smart",
    name: "Startimes Smart",
    biller_name: "Startimes",
    amount: 2200,
    fee: 100,
  },
  {
    id: "classic",
    name: "Startimes Classic",
    biller_name: "Startimes",
    amount: 3300,
    fee: 100,
  },
  {
    id: "super",
    name: "Startimes Super",
    biller_name: "Startimes",
    amount: 4800,
    fee: 100,
  },
];
